<div
  class="form-checkbox"
  [formGroup]="formGroup"
  [class.hovered]="isHovered"
  [class.error]="isInvalid"
  [class.disabled]="controlConfig.disabled">
  <div class="checkbox-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <span class="checkbox-label-text">{{ controlConfig.label }} <span *ngIf="controlConfig.required">*</span> </span>

    <label class="checkbox-label" [id]="controlConfig.name + '-label'" [attr.for]="controlConfig.name">
      <input
        type="checkbox"
        [id]="controlConfig.name"
        [formControlName]="controlConfig.name"
        [required]="controlConfig.required"
        [attr.aria-invalid]="isInvalid"
        [attr.aria-describedby]="'error-message-' + controlConfig.name + ' ' + 'success-message-' + controlConfig.name"
        (change)="onCheckboxChange($event)"
        (keydown)="onKeyDown($event)" />

      <span class="checkbox-custom" [class.checked]="isChecked"></span>

      <span class="label-text" [innerHTML]="controlConfig.checkboxText"></span>
    </label>
  </div>

  <div [id]="'error-message-' + controlConfig.name" aria-live="assertive">
    <span class="error-message" *ngIf="errorMessage">
      <span class="sr-only">Fehler</span>
      {{ errorMessage }}
    </span>
  </div>

  <div [id]="'success-message-' + controlConfig.name" aria-live="assertive">
    <span class="sr-only" *ngIf="isValid">Eingabe gültig</span>
  </div>
</div>
